import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ar from '../assets/locales/ar/translation.json';
import de from '../assets/locales/de/translation.json';
import en_US from '../assets/locales/en_US/translation.json';
import es from '../assets/locales/es/translation.json';
import es_LA from '../assets/locales/es_LA/translation.json';
import el from '../assets/locales/el/translation.json';
import fr_CA from '../assets/locales/fr_CA/translation.json';
import fr_FR from '../assets/locales/fr_FR/translation.json';
import id from '../assets/locales/id/translation.json';
import it from '../assets/locales/it/translation.json';
import ja from '../assets/locales/ja/translation.json';
import ko from '../assets/locales/ko/translation.json';
import nl from '../assets/locales/nl/translation.json';
import pl from '../assets/locales/pl/translation.json';
import pt_BR from '../assets/locales/pt_BR/translation.json';
import ru from '../assets/locales/ru/translation.json';
import tr from '../assets/locales/tr/translation.json';
import zh_CN from '../assets/locales/zh_CN/translation.json';
import zh_TW from '../assets/locales/zh_TW/translation.json';

// the translations
const resources = {
  ar: {
    translation: ar,
  },
  de: {
    translation: de,
  },
  en_US: {
    translation: en_US,
  },
  es: {
    translation: es,
  },
  es_LA: {
    translation: es_LA,
  },
  el: {
    translation: el,
  },
  fr_CA: {
    translation: fr_CA,
  },
  fr_FR: {
    translation: fr_FR,
  },
  id: {
    translation: id,
  },
  it: {
    translation: it,
  },
  ja: {
    translation: ja,
  },
  ko: {
    translation: ko,
  },
  nl: {
    translation: nl,
  },
  pl: {
    translation: pl,
  },
  pt_BR: {
    translation: pt_BR,
  },
  ru: {
    translation: ru,
  },
  tr: {
    translation: tr,
  },
  zh_CN: {
    translation: zh_CN,
  },
  zh_TW: {
    translation: zh_TW,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    debug: false,
    lng: 'en_US',
    fallbackLng: 'en_US',
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
    // allow keys to be phrases containing `:`, `.`
    nsSeparator: false,
    keySeparator: false,
  });

export default i18n;
